import { Text, View } from "react-native";
import React, { useEffect } from 'react';
import { styles } from "./CompleteAccounStyle";
import { translate } from "../../../Common/Utils/translation.utils";
import { ButtonView } from "@levelapp/softfabric-ui";
import { Application, LanguageManager, Managers } from "@levelapp/softfabric";
import HeaderView from "../details/components/header/HeaderView";
import FooterView from "../details/components/footer/FooterView";

export const CompleteAccountView = () => {

    const languageManager = Application.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER);

    useEffect(() => {
        const handlePopState = () => {
            window.history.pushState(null, "", window.location.href);
            window.location.href = `https://beebonds.com`;
        };

        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [languageManager.language]);

    const onInvestButtonPress = () => {
        window.location.href = `https://my.beebonds.com/${languageManager.language}/dashboard/myinvestmentprofile/noinvestmentprofile`;
    }

    return (
        <View style={[styles.page]}>
            <HeaderView />
            <View style={[styles.textxView]}>
                <Text style={[styles.text]}>{translate("completeAccount.title")}</Text>
                <Text style={[styles.text]}>{translate("completeAccount.sentance1")}</Text>
                <Text style={[styles.text]}>{translate("completeAccount.sentance2")}</Text>
            </View>

            <View style={{width: 250, marginLeft: 20}}>
                <ButtonView handleClick={onInvestButtonPress} isLoading={false} animation="None"
                    borders="Little" backgroundColor="#FFA93B">
                    <View style={{
                        ...styles.btn,
                    }}>
                        <Text
                            style={[styles.btnText, styles.textGrey, { fontSize: 14 }]}>{translate("completeAccount.cta")}</Text>
                    </View>
                </ButtonView>
            </View>

            <FooterView />
        </View>
    );
}

export default CompleteAccountView;